"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProcessBuilder = void 0;
var Activity_1 = require("../entities/Process/Activity");
var Process_1 = require("../entities/Process/Process");
var IXgoto_1 = require("../entities/Process/IXgoto");
var SyntaxChecker_1 = require("./SyntaxChecker");
var ProcessBuilder = (function () {
    function ProcessBuilder(yaml) {
        this._defaultType = 'task';
        this._yaml = yaml;
        this._process = new Process_1.Process(yaml.version, new Array(), yaml.process, yaml.defaultType);
    }
    ProcessBuilder.prototype.Builder = function (nodeIds) {
        if (this._yaml.activities !== undefined) {
            this._process.activities = this.ActivityBuilderBase(this._yaml.activities);
        }
        this._process.$nodeIds = nodeIds;
        return this._process;
    };
    ProcessBuilder.prototype.ActivityBuilderBase = function (acts) {
        var implicitGoto = this.HaveImplicitGoto(acts);
        var activities = [];
        var prevAct;
        for (var a in acts) {
            if (acts[a] === null)
                acts[a] = {};
            if (implicitGoto) {
                if (prevAct !== undefined) {
                    prevAct[1].goto = a;
                    activities.push(this.ActivityBuilder(prevAct[0], prevAct[1]));
                }
                prevAct = [a, acts[a]];
            }
            else
                activities.push(this.ActivityBuilder(a, acts[a]));
        }
        if (implicitGoto)
            activities.push(this.ActivityBuilder(prevAct[0], prevAct[1]));
        return activities;
    };
    ProcessBuilder.prototype.HaveImplicitGoto = function (activities) {
        for (var a in activities) {
            if (activities[a] !== null && (activities[a].goto !== undefined ||
                activities[a].pgoto !== undefined ||
                activities[a].xgoto !== undefined ||
                activities[a].igoto !== undefined))
                return false;
        }
        return true;
    };
    ProcessBuilder.prototype.ActivityBuilder = function (name, YAMLact) {
        var act = new Activity_1.Activity(name);
        if (YAMLact.type !== undefined) {
            act.type = YAMLact.type;
        }
        else if (this._process.defaultType !== undefined) {
            act.type = this._process.defaultType;
        }
        else {
            act.type = this._defaultType;
        }
        if (YAMLact.goto !== undefined) {
            if (SyntaxChecker_1.ConditionalGotoActivities.includes(YAMLact.type)) {
                act.goto = new Array();
                var gotoes = YAMLact.goto;
                for (var x in gotoes) {
                    act.goto.push(this.IXgotoBuilder(gotoes[x]));
                }
            }
            else
                act.goto = YAMLact.goto;
        }
        else if (YAMLact.pgoto !== undefined) {
            act.pgoto = YAMLact.pgoto;
        }
        else if (YAMLact.xgoto !== undefined) {
            act.xgoto = new Array();
            for (var x in YAMLact.xgoto) {
                act.xgoto.push(this.IXgotoBuilder(YAMLact.xgoto[x]));
            }
        }
        else if (YAMLact.igoto !== undefined) {
            act.igoto = new Array();
            for (var i in YAMLact.igoto) {
                act.igoto.push(this.IXgotoBuilder(YAMLact.igoto[i]));
            }
        }
        if (YAMLact.activities !== undefined) {
            act.activities = this.ActivityBuilderBase(YAMLact.activities);
        }
        if (YAMLact.condition !== undefined) {
            act.condition = YAMLact.condition;
        }
        return act;
    };
    ProcessBuilder.prototype.IXgotoBuilder = function (YAMLixgt) {
        return new IXgoto_1.IXgoto(YAMLixgt.if, YAMLixgt.then);
    };
    return ProcessBuilder;
}());
exports.ProcessBuilder = ProcessBuilder;
//# sourceMappingURL=ProcessBuilder.js.map